<style>
.page-item{
        cursor:pointer;
}
.skeleton-line {
  height: 14px;
  width: 100%;
  background: linear-gradient(
    90deg,
    #eeeeee 25%,
    #dddddd 37%,
    #eeeeee 63%
  );
  background-size: 400% 100%;
  animation: skeleton-loading 1.4s ease infinite;
  border-radius: 4px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}

.text-muted i {
  color: #999;
}

</style>

<template>
  <section class="content">
    <div class="container-fluid">
		<div class="row">
            <div class="col-12">
                <h3 class="card-title">Mutasi Keluar</h3>
            </div>  
        </div>
       
		<!-- TOOLBAR FILTER TAHUN (DI ATAS CARD) -->
		<div class="d-flex justify-content-between align-items-center mb-2">

		  <!-- KIRI  -->
		  <div>
			  <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                    <i class="fa fa-plus-square"></i>
                    Tambah Mutasi Keluar
                </button>
			</div>

		  <!-- KANAN (ABSOLUTE) -->
		  <div class="d-flex align-items-center">		
			  <label class="mr-2 font-weight-bold mb-0">Tahun</label>
			  <select
				v-model="tahunMutasiKeluar"
				class="form-control form-control-sm"
				style="width:130px"
				@change="getResults(1)"
			  >
				<option value="">Pilih</option>
				<option v-for="t in listTahunMutasiKeluar" :key="t" :value="t">
				  {{ t }}
				</option>
			  </select>
			</div>
		</div>
		
		<!-- TABEL -->		
		
        <div class="row">
          <div class="col-12">        
            <div class="card">
        
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Tanggal Mutasi</th>
                      <th>Sumber Dana</th>
                      <th>Unit Penerima</th>
                      <th style="text-align:right">Total (Rp)</th>
                      <th>Status</th>
                      <th>Keterangan</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
					<!-- SKELETON -->
					<template v-if="isLoadingTable">
						<tr v-for="n in 5" :key="'sk-'+n">
						  <td colspan="10">
							<div class="skeleton-line"></div>
						  </td>
						</tr>
					</template>

					<!-- BELUM PILIH TAHUN -->
					<tr v-else-if="!tahunMutasiKeluar">
						<td colspan="10" class="text-center text-muted py-4">
						  Silakan pilih tahun untuk menampilkan data
						</td>
					</tr>

					<!-- DATA KOSONG -->
					<tr v-else-if="isDataKosong">
						<td colspan="10" class="text-center text-muted py-4">
						  <i class="fa fa-info-circle mr-1"></i>
						  Belum ada transaksi mutasi keluar pada tahun
						  <strong>{{ tahunMutasiKeluar }}</strong>
						</td>
					</tr>
					
                     <tr v-for="barangkeluar in barangkeluars.data" :key="barangkeluar.id">

                      <td>{{barangkeluar.id}}</td>
                      <td class="text-capitalize">{{barangkeluar.tanggal_keluar}}</td>
                      <td>{{barangkeluar.nama_sumber_dana}}</td>
                      <td>{{barangkeluar.nama_penerima}}</td>
                      <td style="text-align:right">{{returnRupiah(barangkeluar.total)}}</td>
                      <td v-if="barangkeluar.status_diterima == '0'">
                          <span class="btn btn-warning" style="padding:0px 5px;">Menunggu</span></td>
                      <td v-else-if="barangkeluar.status_diterima == '1'">
                          <span class="btn btn-success" style="padding:0px 5px;">Diterima pada {{barangkeluar.tanggal_diterima}}</span></td>
                       <td v-else-if="barangkeluar.status_diterima == '2'">
                           <span class="btn btn-danger" style="padding:0px 5px;">Ditolak</span> | 
                       <a href="#" @click="kirimUlang(barangkeluar.id)">
                            <i class="fa fa-share-square green" v-b-tooltip.hover title="Kirim Ulang"></i>
                        </a>
                       </td>
                      <td>{{barangkeluar.keterangan}}</td>

                      <td v-if="barangkeluar.status_diterima != '1'">
                        <!--<router-link :to='"/detail_mutasi_keluar?barang_keluar_id=" + barangkeluar.id' >
                                <i class="nav-icon fas fa-list-ul red"></i>
                            </router-link>-->
							
						<router-link :to="{path: '/detail_mutasi_keluar', query: {barang_keluar_id: barangkeluar.id, tahun: tahunMutasiKeluar}}">
									<i class="nav-icon fas fa-list-ul red"></i>
								</router-link>	

                         | 
                         <a href="#" @click="editModal(barangkeluar)">
                            <i class="fa fa-edit blue"></i>
                        </a>
                        |
                        <a href="#" @click="deleteData(barangkeluar.id)">
                            <i class="fa fa-trash red"></i>
                        </a>
                      </td>
                      <td v-else>
                          <!--<router-link :to='"/detail_mutasi_keluar?barang_keluar_id=" + barangkeluar.id' >
                                <i class="nav-icon fas fa-list-ul red"></i>
                            </router-link>-->
							
							<router-link :to="{path: '/detail_mutasi_keluar', query: {barang_keluar_id: barangkeluar.id, tahun: tahunMutasiKeluar}}">
									<i class="nav-icon fas fa-list-ul red"></i>
								</router-link>
								
                      </td>
                    </tr>

                    <tr>
                        <td colspan="4" style="font-weight:bold; text-align:center;">Grand Total</td>
                        <td style="font-weight:bold; text-align:right;">{{returnRupiah(grandtotal)}}</td>
                        <td colspan="3"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <pagination :data="barangkeluars" @pagination-change-page="getResults"></pagination>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>


        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Tambah Mutasi Keluar</h5>
                    <h5 class="modal-title" v-show="editmode">Ubah Mutasi Keluar</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updateBarangKeluar() : createBarangKeluar()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Tanggal Mutasi</label>
                            <datepicker v-model="form.tanggal_keluar" :disabledDates="disabledAkhir" :format="format"  name="tanggal_keluar" class="form-controlx" :class="{ 'is-invalid': form.errors.has('tanggal_keluar') }"></datepicker>
                            <has-error :form="form" field="tanggal_keluar"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Sumber Dana</label>
                            <select v-model="form.sumber_dana_id" name="sumber_dana_id" class="form-control" :class="{ 'is-invalid': form.errors.has('Sumber Dana') }">
                             <option selected value="">Pilih salah satu</option>

                            <option v-for="sumberdana in sumberdanas" :value="sumberdana.id">
                                {{ sumberdana.nama }}
                            </option>

                            </select>
                            <has-error :form="form" field="sumber_dana_id"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Unit Penerima</label>
                            <select v-model="form.unit_kerja_id" name="unit_kerja_id" class="form-control" :class="{ 'is-invalid': form.errors.has('Unit Kerja') }">
                             <option selected value="">Pilih salah satu</option>

                            <option v-for="unitkerja in unitkerjas" :value="unitkerja.id">
                                {{ unitkerja.nama }}
                            </option>

                            </select>
                            <has-error :form="form" field="unit_kerja_id"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Keterangan Penerimaan/ Penolakan</label>
                             <textarea v-model="form.keterangan" name="keterangan"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('keterangan') }">
                                </textarea>
                            <has-error :form="form" field="keterangan"></has-error>
                        </div>
                    </div>
                   
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Simpan</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Simpan</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

    export default {
        components: {
            Datepicker
        },
        data () {
            return {
                editmode: false,
                barangkeluars : {},
                unitkerjas : {},
                sumberdanas : {},
                format: 'yyyy-MM-dd',
                akhir:'',
                grandtotal :0,
                disabledAkhir: {
                    dates:[
                        //new Date(2022, 0, 1)
                    ],
                    ranges: [{ // Disable dates in given ranges (exclusive).
                        from: new Date(),
                        to: new Date(2100, 11, 31)
                    }]
                },
                form: new Form({
                    id : '',      
                    tanggal_keluar: '',
                    unit_kerja_id: '',
                    sumber_dana_id: '',
                    id_penerima:'',
                    keterangan:'',
                    total:''

                }),
				tahunMutasiKeluar: this.$route.query.tahun ? parseInt(this.$route.query.tahun) : new Date().getFullYear(),
				listTahunMutasiKeluar: [],
				isLoadingTable: false, // ⬅️ untuk skeleton
            }
        },
		
		computed: {			
			isDataKosong() {
				return (
				  !this.isLoadingTable &&
				  this.tahunMutasiKeluar &&
				  this.barangkeluars?.data &&
				  this.barangkeluars.data.length === 0
				)
			  }
		},
		
        methods: {
		/*
            returnRupiah(val){
                var number_string = val.toString(),
                    split	= number_string.split(','),
                    sisa 	= split[0].length % 3,
                    rupiah 	= split[0].substr(0, sisa),
                    ribuan 	= split[0].substr(sisa).match(/\d{1,3}/gi);
                    
                if (ribuan) {
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }
                
                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                if(parseFloat(rupiah) == 0){
                    val = 0;
                }else{
                    val = rupiah;
                }
                
                return val;
            },*/
			returnRupiah(val){
				if(val === null || val === '' || val === undefined)
					return '0,00';

				return Number(val).toLocaleString('id-ID',{
					minimumFractionDigits:2,
					maximumFractionDigits:2
				});
			},
			
			sortRecords (index, tableName) {				
				this.sortIndex = index
				  this.showTable = tableName

				  this.sortDirection =
					this.sortDirection === 'asc' ? 'desc' : 'asc'

				  this.page = 1
				  this.getResults(1)
            },    
            changePageRange(){				  
				this.page = 1
				this.getResults(1) 
            },

            getResults(page = 1) {

                  /*this.$Progress.start();
                  
                  axios.get('/api/mutasi_keluar?page=' + page).then(({ data }) => (this.barangkeluars = data.data.barang_keluar, this.sumberdanas = data.data.sumber_dana, this.unitkerjas = data.data.unit_kerja, this.grandtotal = data.data.grand_total));

                  this.$Progress.finish();*/
				  
				  // ⛔ jangan load data kalau tahun belum dipilih
				  if (!this.tahunMutasiKeluar) {
					this.barangkeluars = { data: [], total: 0 }
					return
				  }

				  this.isLoadingTable = true
				  this.$Progress.start()

				  axios.get('/api/mutasi_keluar', {
					params: {
					  page: page,
					  tahun: this.tahunMutasiKeluar,
					  sortIndex: this.sortIndex,
					  sortDirection: this.sortDirection,
					  showPage: this.perPage,
					  showTable: this.showTable
					}
				  }).then(({ data }) => {
					this.barangkeluars = data.data.barang_keluar
					this.sumberdanas  = data.data.sumber_dana
					this.unitkerjas   = data.data.unit_kerja
					this.grandtotal = data.data.grand_total
				  }).finally(() => {
					this.isLoadingTable = false
					this.$Progress.finish()
				  })
            },
            updateBarangKeluar(){
                this.$Progress.start();
                this.form.put('/api/mutasi_keluar/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadBarangKeluars();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },

            deleteData(id){
              Swal.fire({
                  title: 'Apa anda yakin?',
                  text: "Setelah terhapus data tidak bisa dikembalikan!",
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Ya'
                  }).then((result) => {

                      // Send request to the server
                        if (result.value) {
                            this.form.delete('/api/mutasi_keluar/'+id)
                            .then((response)=>{
                                
                                Toast.fire({
                                        icon: 'success',
                                        title: response.data.message
                                });

                                this.$Progress.finish();

                            })
                            .catch(()=>{
                                Toast.fire({
                                    icon: 'error',
                                    title: 'Some error occured! Please try again'
                                });
                            })

                            window.location.reload();
                        }
                  })
             },
            editModal(barang_keluar){
                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(barang_keluar);
            },
            newModal(){
                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');
            },

            loadBarangKeluars(){
           
                    axios.get("/api/mutasi_keluar").then(({ data }) => (this.barangkeluars = data.data.barang_keluar, this.sumberdanas = data.data.sumber_dana, this.unitkerjas = data.data.unit_kerja, this.grandtotal = data.data.grand_total));            
            },
            kirimUlang(id){
                Swal.fire({
                  title: 'Apa anda yakin?',
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Ya'
                  }).then((result) => {

                      // Send request to the server
                        if (result.value) {
                            this.form.put('/api/mutasi_keluar/kirim/'+id)
                            .then((response)=>{
                                
                                Toast.fire({
                                        icon: 'success',
                                        title: response.data.message
                                });

                                this.$Progress.finish();

                            })
                            .catch(()=>{
                                Toast.fire({
                                    icon: 'error',
                                    title: 'Some error occured! Please try again'
                                });
                            })

                            window.location.reload();
                        }
                  })
            },
            
            createBarangKeluar(){

                this.form.post('/api/mutasi_keluar')
                .then((response)=>{
                    $('#addNew').modal('hide');

                    Toast.fire({
                            icon: 'success',
                            title: response.data.message
                    });

                    this.$Progress.finish();
                    this.loadBarangKeluars();
                })
                .catch(()=>{
                    Toast.fire({
                        icon: 'error',
                        title: 'Some error occured! Please try again'
                    });
                })
            }

        },
        mounted() {
            console.log('Component mounted.')
        },
        created() {
            this.$Progress.start();
            //this.loadBarangKeluars();
			const now = new Date().getFullYear()
			for (let i = 0; i < 2; i++) {
				this.listTahunMutasiKeluar.push(now - i)
			}
			// ⬅️ langsung load data tahun berjalan
			this.getResults(1)
            this.$Progress.finish();

        }
    }

    function returnRupiah(val){
                var number_string = val.toString(),
                    split	= number_string.split(','),
                    sisa 	= split[0].length % 3,
                    rupiah 	= split[0].substr(0, sisa),
                    ribuan 	= split[0].substr(sisa).match(/\d{1,3}/gi);
                    
                if (ribuan) {
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }
                
                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                if(parseFloat(rupiah) == 0){
                    val = 0;
                }else{
                    val = rupiah;
                }
                
                return val;
            }
</script>